/**
 * Autocomplete and Joules term-search item cap.
 * Keep in sync with MAX_RESPONSE_ENTRIES in app/(api)/data/routesHelper.ts
 */
export const SUGGESTION_LIMIT = 10;

/** Skip per-keystroke Joules term search when local cache already yields at least this many hits. */
export const JOULES_FALLBACK_MIN_LOCAL_RESULTS = 3;
